import { gql } from '@apollo/client';

export const GET_NOTIFICACIONES_ROL = gql`
    query GetNotificacionRol($idRol: Int!) {
        notificacionRol(idRol: $idRol) {
            success
            error
            valorEsperado {
                idNotificacionTipo
                obligatorio
            }
        }
    }
`;